import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UiModule } from 'src/app/ui';
import { PublishingState } from '../../states/publishing.state';

@Component({
  selector: 'rk-ios-screenshot',
  imports: [AsyncPipe, TranslatePipe, UiModule],
  templateUrl: './ios-screenshot.component.html',
  styleUrl: './ios-screenshot.component.scss',
})
export class IosScreenshotComponent {
  window = window;
  iosScreenshot$: Observable<string> = inject(Store).select(
    PublishingState.iosScreenshot,
  );
  appStoreLink$: Observable<string> = inject(Store).select(PublishingState.appStoreLink);
}
